module.exports = __webpack_public_path__ + "img/40_69_014_530.48045d3d.jpg";